import React from 'react'
import { PageHeader } from '../pageHeader/PageHeader'
import { TicketCreateModal } from '../../pages/task/shared/TicketCreateModal';

export const PageLayout = ({ children }) => {
  return (
    <main className="nxl-container">
        <div className="nxl-content">
            <PageHeader />
            <div className="main-content">
                {children}
            </div>
            <TicketCreateModal />
        </div>
    </main> 
  )
}
